import { render, staticRenderFns } from "./add-position.vue?vue&type=template&id=2f153b3c"
import script from "./add-position.vue?vue&type=script&lang=js"
export * from "./add-position.vue?vue&type=script&lang=js"
import style0 from "./add-position.vue?vue&type=style&index=0&id=2f153b3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports